// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-field-container[data-v-8eed253e]{font-size:14px;padding-top:0}.text-field-container[data-v-8eed253e] .v-text-field__slot{padding-left:4px}", ""]);
// Exports
module.exports = exports;
